/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureAksCluster extends models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureAksCluster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureAksCluster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureAksCluster>): ServiceAccountNativeDetailsForAzureAksCluster {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureAksCluster(), model);
        ServiceAccountNativeDetailsForAzureAksCluster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureAksCluster>): ServiceAccountNativeDetailsForAzureAksCluster {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureAksCluster.newInstance(<ServiceAccountNativeDetailsForAzureAksCluster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureAksCluster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureAksCluster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureAksCluster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureAksCluster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
